import logo from './logo.svg';
import NavHeader from './Components/NavHeader/NavHeader';
import { Footer } from '@ux/balance-react';
import HomePage from './Pages/HomePage/HomePage';
import Logout from './Pages/Logout/Logout';
import VideoPlayer from './Components/VideoPlayer/VideoPlayer';
import OktaConfig from './Data/OktaConfig';
import { Security, LoginCallback, SecureRoute } from '@okta/okta-react';
import { OktaAuth } from '@okta/okta-auth-js';
import { Route, Switch, useHistory } from 'react-router-dom';


const oktaAuth = new OktaAuth(OktaConfig.oidc);

function App() {
  const history = useHistory()

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace('/');
  };

  const customAuthHandler = () => {
      history.push('/');
  };  

  const onAuthResume = async () => {
      history.push('/');
  };

  return (
    <div className="App">
      <NavHeader />
      { OktaConfig.USE_OKTA ? 
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}  >
          <Switch>
            <Route path="/login/callback" render={ (props) => <LoginCallback {...props} onAuthResume={onAuthResume} />} />
            <SecureRoute exact path="/" render={() => <HomePage />} />
            <Route exact path="/logout" render={() => <Logout />} />
          </Switch>
        </Security>
        :
        <Switch>
          <Route exact path="/" render={() => <HomePage />} />
        </Switch>
      }
      <Footer />
    </div>
  );
}

export default App;
